import { dao } from '@platform/dao';
import type { IActivityCount, IActivityCountQuery, IActivityList, IActivityQuery } from '@platform/dao';
import { baseApi, run } from './baseApi';

/**
 * Стрічка активності робочого простору (Головна «Нещодавня активність», Адміністрування «Нещодавні зміни», «Зміни · 7 днів», журнал
 * аудиту): сторінки подій курсором before; кількість подій за дні чи загалом (GET …/activity/count); кеш на хвилину, оновлюється разом зі
 * списками записів. Фільтри журналу аудиту (автор, тип запису, пошук) застосовує сервер — і до стрічки, і до кількості.
 */
export const activityApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    workspaceActivity: b.query<IActivityList, IActivityQuery>({
      queryFn: (q) => run(() => dao.workspaces.activity(q)),
      providesTags: (_r, _e, q) => [{ type: 'Workspaces', id: `activity:${q.ws}` }, 'RecordList'],
    }),
    activityCount: b.query<IActivityCount, IActivityCountQuery>({
      queryFn: (c) => run(() => dao.workspaces.activityCount(c)),
      providesTags: (_r, _e, q) => [{ type: 'Workspaces', id: `activity:${q.ws}` }, 'RecordList'],
    }),
  }),
});

export const { useWorkspaceActivityQuery, useActivityCountQuery } = activityApi;
